import {BasicEventPlayer} from "../auth/BasicEventPlayer";
import {SimplePlayer} from "../players/SimplePlayer";

export interface EventBooth {
  id: string;
  name: string;
  type: BoothType;
  owner: SimplePlayer;
  members: SimplePlayer[];
  purchaseState: BoothPurchase;
  approvalState: BoothApproval;
}

export enum BoothType {
  SMALL,
  MEDIUM,
  LARGE,
  HALL,
  BIG
}

export interface BoothApproval {
  state: BoothBuildState;
  message?: string;
  reviewer?: SimplePlayer;
  time: number;
}

export interface BoothPurchase {
  state: BoothPurchaseState;
  message?: string;
  reviewer?: SimplePlayer;
  time: number;
}

export interface Dated<T> {
  change: T;
  time: string;
}

export interface BoothHistory {
  approvalChanges: BoothApproval[];
  purchaseChanges: BoothPurchase[];
}

export enum BoothPurchaseState {
  APPLIED = "APPLIED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  PAID = "PAID"
}

export enum BoothBuildState {
  CREATED = "CREATED",
  MODIFIED = "MODIFIED",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  NEEDS_CHANGES = "NEEDS_CHANGES",
  ENTRY_APPROVED = "ENTRY_APPROVED",
  ENTRY_DENIED = "ENTRY_DENIED",
  INSERTED = "INSERTED",
  REMOVED = "REMOVED"
}
